export const APP_CONSTANTS = {
  MAIL: 'sohtinyhouse@gmail.com',
  DISPLAY_PHONE: '+40 735 699 978',
  FUNCTIONAL_PHONE: '40735699978',
  ADRESS: 'Bethausen nr. 350, jud. Timiș',
  FACEBOOK: 'https://www.facebook.com/profile.php?id=61559028520422',
  INSTAGRAM: 'https://www.instagram.com/sohtinyhouse/',
  TIKTOK: 'https://www.tiktok.com/@sohtinyhouse',
  GOOGLE_MAPS_LOCATION: 'https://maps.app.goo.gl/TzCVuZznYGaqWmHY9',
} as const;
